<script>
import UiLoading from './Loading';

export default {
    components: {
        UiLoading,
    },
    props: {
        visible: Boolean,
        loading: Boolean,
        maxWidth: {
            type: Number,
            default: 480,
        },
    },
};
</script>

<template>
    <div v-if="visible" class="ModalOverlay">
        <div :class="['Modal', {Loading: this.loading}]" :style="{'max-width': `${maxWidth}px`}">
            <slot></slot>
            <div class="LoadingOverlay">
                <ui-loading />
            </div>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.ModalOverlay
    position fixed
    top 0
    right 0
    bottom 0
    left 0
    background rgba(255,255,255,.5)
    z-index 1000
    display flex
    align-items center
    justify-content center
    .Modal
        box-sizing border-box
        position absolute
        z-index 1001
        width 90%
        background #fff
        border 2px solid $cBorder
        box-shadow 0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)
        padding 35px
        .LoadingOverlay
            display flex
            justify-content center
            align-items center
            position absolute
            top 100%
            right 0
            bottom 0
            left 0
            background rgba(255,255,255,.6)
            transition .3s all
            overflow hidden
        &.Loading .LoadingOverlay
            top 0


</style>


